var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"display-3 v-heading mb-3 font-weight-light"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }